import { createSelector } from 'reselect';
var selectState = function (state) { return state.get('department'); };
export var selectShouldLoadAll = createSelector(selectState, function (departmentsState) {
    return !departmentsState.get('loadingAll') && !departmentsState.get('loadedAll');
});
export var selectAll = createSelector(selectState, function (departmentsState) {
    return departmentsState.get('data');
});
